'use client';

import * as React from 'react';
import { Player } from '@alien-platform/bo-core';
import { useColorScheme } from '@mui/material';

import JsonView from '@/components/core/json-view';

export function PlayerJsonTab({ playerData }: { playerData: Player | undefined }): React.JSX.Element | null {
  const { colorScheme } = useColorScheme();

  return playerData ? (
    <JsonView src={playerData} theme={colorScheme === 'dark' ? 'monokai' : 'bright:inverted'} />
  ) : null;
}
